import React from 'react'
import { ItemProps } from '@/components/Form/types'

import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'
import { HatchPatternFormData } from '@/types/hatchProfile'
import hatchPatternFormItems from '@/components/HatchProfile/forms/hatchPatternFormItems'
import { Button } from '@/components/UiElements'
import HatchPatternForm from '@/components/HatchProfile/HatchPatternForm'
import Modal from '@/components/Modal/Modal'


const HatchPatterList: React.FC<ItemProps> = (props) => {

	const list = props.formData?.[props.formItem.name] || []
	const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false)
	const [selectedPattern, setSelectedPattern] = React.useState<HatchPatternFormData | null>(null)


	const handleCloseModal = () => {
		setIsModalOpen(false)
		setSelectedPattern(null)
	}

	const handleDeleteItem = (item:HatchPatternFormData) => {
		const filteredList = list.filter((I: HatchPatternFormData) => I.id !== item.id)
		props?.onChange?.(props.formItem.name, filteredList)
	}

	const handleOnUpdateSuccess = (data:HatchPatternFormData) =>{
		if (selectedPattern) {
			// Update existing
			const updatedList = list.map((item: HatchPatternFormData) => {
				if (item.id === selectedPattern.id) {
					return data
				}
				return item
			})
			console.log(updatedList)
			props?.onChange?.(props.formItem.name, updatedList)
		} else {
			// Add new
			const newList = [...list, data]
			console.log(newList)
			props?.onChange?.(props.formItem.name, newList)
		}
		handleCloseModal()

	}



	const handleAddNewPattern = () => {
		setSelectedPattern(null)
		setIsModalOpen(true)
	}




	return (
		<>
			<Modal isOpen={isModalOpen} onClose={() => handleCloseModal()} title={selectedPattern ?  "Edit Hatch profile" : "Add Hatch profile"} closeOnOutsideClick={false}>
				<HatchPatternForm pattern={selectedPattern} onUpdateSuccess={handleOnUpdateSuccess}/>
			</Modal>

			<div className={'flex flex-col gap-sm'}>
				{list.map((item: HatchPatternFormData, index: number) => {

					const hatch_type = hatchPatternFormItems.find(h => h.name === 'hatch_type')?.itemOptions?.list
					const hatch_style = hatchPatternFormItems.find(h => h.name === 'hatch_style')?.itemOptions?.list
					const corner_style = hatchPatternFormItems.find(h => h.name === 'corner_style')?.itemOptions?.list
					return (

						<div
							className={
								'flex justify-start items-center  px-md  h-[44px] min-h-[44px] relative inset-1 flex-1 ' +
								'text-text-md text-gray-900 rounded-md border  border-gray-300  hover:border-primary-500  left-0 cursor-pointer ' +
								'cursor-pointer transition-all shadow-xs active:shadow-focus group gap-md ' +
								`${JSON.stringify(selectedPattern) === JSON.stringify(item) ? 'border-primary-500 !shadow-focus bg-primary-100 ' : ''}`
							}
							onClick={() => {
								setSelectedPattern(item)
								setIsModalOpen(true)
							}}
							key={index}
						>
							<span className={'text-title-md'}>
								{
									hatch_type?.find(opt => opt.value === item.hatch_type?.value)?.label
								}
							</span>-
							<span className={'text-text-md'}>
								{
									hatch_style?.find(opt => opt.value === item.hatch_style?.value)?.label
								}
							</span>-
							<span className={'text-text-md'}>
								{
									corner_style?.find(opt => opt.value === item.corner_style?.value)?.label
								}
							</span>
							<DeleteAbsoluteButton onClick={() => {
								handleDeleteItem(item)
							}} />
						</div>

					)
				})}
				<div className={'mt-md'}>
					<Button
						type={'alt'}
						size={'sm'}
						className={' !flex-row flex w-auto'}
						onClick={handleAddNewPattern}
					>
						<div className={'flex flex-row gap-md'}>
							<span className={'font-icon-solid'}>+</span>
							Add Pattern
						</div>
					</Button>
				</div>

			</div>
		</>


	)

}

export default HatchPatterList